"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "de": {
        "translation": {
            "global_navigation": {
                "navigation_items": {
                    "logo": "Zurück zum Launchpad",
                    "app_switcher": "Apps wechseln",
                    "announcer": "Ankündigungen",
                    "helper": "Hilfe und Support",
                    "user": "Angemeldet: {{username}}",
                    "user_with_customer": "{{username}} {{customerName}}",
                    "sign_in": "Anmelden"
                },
                "apps": {
                    "academy": "Akademie",
                    "community": "Community",
                    "projects": "Projekte",
                    "results": "Ergebnisse",
                    "storyboards": "Storyboards",
                    "mission_control": "Kontrollzentrum",
                    "risks": "Strategie",
                    "reports": "Berichte",
                    "launchpad": "Launchpad",
                    "robots": "Robots",
                    "frameworks": "Frameworks",
                    "compliance_maps": "Compliance-Maps",
                    "assurance_plans": "Sicherungspläne",
                    "project_scheduler": "Ablaufplaner",
                    "issue_tracker": "Problemverfolgung",
                    "task_tracker": "Aufgabenverfolgung",
                    "project_timesheets": "Stundennachweise",
                    "dashboard": "{{module}}-Dashboard",
                    "master_library": "Master-Bibliothek"
                },
                "app_sections": {
                    "setup": "Einstellungen",
                    "workspace": "Arbeitsbereich",
                    "automation": "Automatisierung"
                },
                "user": {
                    "my_profile": "Mein Profil",
                    "log_out": "Abmelden"
                },
                "helper": {
                    "help_docs": "Hilfedokumente",
                    "support": "Support"
                },
                "skip_button": "Bis Hauptinhalt überspringen",
                "logo": "Logo",
                "other": "Andere",
                "section": "Abschnitt"
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=de.js.map